// import BudgetProgress, { ProgressType } from 'components/budgetProgress/budgetProgress';
import {
  BackgroundImage,
  Box,
  Center,
  Container,
  Grid,
  Title,
} from "@mantine/core";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import Login from "./features/login/Login";
// import logo from '../../assets/images/altitude-lg.png'
import logo from "../../assets/images/altitude-brand2.png";
import onsetLogo from "../../assets/images/onset-logo.svg";
import { authUserSuccess, cleanRequests } from "./authSlice";
import { AltHistory } from "../../utils/history";
import { useNavigate } from "react-router-dom";
// import Register from './features/register/Register';
// import Access from './features/access/Access';
// import ForgotPassword from './features/login/ForgotPassword';
import { notifications } from "@mantine/notifications";
import { setPreviousRoute } from "./../../app/appSlice";
import { createStyles } from "@mantine/emotion";
import Register from "./features/register/Register";
import ForgotPassword from "./features/login/ForgotPassword";
import Access from "./features/access/Access";

import classes from './Auth.module.scss';

const Auth = ({
  success,
  error,
  cleanRequests,
  previousRoute,
  setPreviousRoute,
}) => {
  
  const history = AltHistory(useNavigate());
  const location = useLocation();

  useEffect(() => {
    if (success && success.type === authUserSuccess.toString()) {
      // clear the auth response states so we don't loop
      cleanRequests();

      // take them through to the app but check if they have a previous route to redirect too
      const searchParams = new URLSearchParams(location.search);
      if (
        location.search &&
        location.search.length &&
        searchParams.get("redirect") &&
        searchParams.get("redirect").length
      ) {
        const route = decodeURIComponent(searchParams.get("redirect"));
        history.push(route, true);
      } else {
        history.push(`/`);
      }
    }

    if (error) {
      notifications.show({
        position: "top-center",
        color: "red",
        title: "Authentication error",
        message: error.message,
      });
      cleanRequests();
    }
  }, [success, error, cleanRequests, history]);

  // const containerStyle = { width:'1000px', marginTop:'20%', paddingLeft:'20%'}
  return (
    <div className={classes.authWrapper} id="auth-management">
      <div className={classes.bgImageContainer}>
        <Container className={classes.container}>
          <Grid className={classes.container} sx={{ margin: 0 }}>
            <Grid.Col
              className={classes.col}
              span={{ base: 12, md: 5 }}
              style={{ boxShadow: "10px 0 10px rgba(0, 0, 0, 0.2)", zIndex: 1 }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  maxWidth: 400,
                  height: "100vh",
                }}
              >
                <Box mt={"xl"}>
                  <img alt="Onset Logo" src={onsetLogo} width="30" />
                </Box>
                <Box
                  style={{
                    flexGrow: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route
                      path="/forgotpassword"
                      element={<ForgotPassword />}
                    />
                    <Route path="/access/:setupPhrase" element={<Access />} />
                    <Route
                      exact
                      path="/access/:setupPhrase"
                      element={<Access />}
                    />
                    <Route
                      exact
                      path="/*"
                      element={<Navigate to="/auth/login" replace />}
                    />
                  </Routes>
                </Box>
              </div>
            </Grid.Col>
            <Grid.Col span={7} visibleFrom="sm" style={{ padding: 0 }}>
              <BackgroundImage
                style={{ height: "101vh" }}
                src="./../../assets/images/auth-hero.jpeg"
              >
                {/* <VideoBackground
                videoSource="./../../assets/video/video-bg.mp4"
                fallbackImage="/path/to/fallback/image.jpg"
              > */}
                <Container className={classes.container}>
                  <Center className={classes.welcomeContainer}>
                    <Box sx={{ width: 300 }}>
                      <img alt="Altitude Logo" src={logo} width="300" />
                      <Title order={3} mt="sm" className={classes.title}>
                        Photographic workflow made easy
                      </Title>
                    </Box>
                  </Center>
                </Container>
              </BackgroundImage>

              {/* </VideoBackground> */}
            </Grid.Col>
          </Grid>
        </Container>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    user: state.auth.user,
    success: state.auth.success,
    error: state.auth.error,
    previousRoute: state.appReducer.previousRoute,
  };
};

const mapDispatch = { cleanRequests, setPreviousRoute };

export default connect(mapStateToProps, mapDispatch)(Auth);
